import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHistory = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M13.571 2.571A9.43 9.43 0 004.143 12H1l4.075 4.075.073.147L9.381 12H6.238c0-4.054 3.28-7.333 7.333-7.333S20.905 7.946 20.905 12s-3.28 7.333-7.333 7.333a7.274 7.274 0 01-5.176-2.158L6.91 18.663a9.381 9.381 0 006.663 2.766 9.43 9.43 0 000-18.857zM12.524 7.81v5.239l4.484 2.66.754-1.267-3.667-2.179V7.809h-1.571z"
  })
});
export default SvgHistory;